module.exports = __webpack_public_path__ + "img/pro_logo.d089040c.png";